import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";

interface ForwardModalProps {
  readonly mailAddress: string;
  readonly handleCopy: () => void;
  readonly onClose: () => void;
}

function ForwardModal({ mailAddress, handleCopy, onClose }: ForwardModalProps) {
  const { t } = useTranslation();
  const handleCopyButton = () => {
    onClose();
    handleCopy();
  };

  const headerContent = () => (
    <div className="flex w-full justify-between " data-testid="headerContent">
      <span className="font-bold" data-testid="forwardMail">
        {t("Forward")}
      </span>
    </div>
  );

  const modelContent = () => (
    <div className="w-full px-8">
      <div className="w-full p-3 my-4 bg-[#ECF3FE]" data-testid="forwardMailAddress">
        {mailAddress}
      </div>
    </div>
  );

  const footerContent = () => (
    <div className="flex gap-6 px-8 pb-4">
      <ButtonComponent
        buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
        onClick={handleCopyButton}
        data-testid="copyForwardMailBtn"
      >
        {t("Copy Link")}
      </ButtonComponent>
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={onClose} data-testid="cancelForwardMailBtn">
        {t("Cancel")}
      </ButtonComponent>
    </div>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      width="40%"
      onCancel={onClose}
      // headerTitle="Forward"
      headerTitle={headerContent()}
      modelContent={modelContent()}
      footerContent={footerContent()}
      allowModalPadding={false}
    />
  );
}

export default ForwardModal;
